var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('a-spin', {
    attrs: {
      "spinning": _vm.loading
    }
  }, [_c('a-row', {
    staticClass: "text-center",
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    staticClass: "text-left",
    attrs: {
      "span": 24
    }
  }, [_c('h5', {
    staticClass: "mb-1"
  }), _c('a-form', {
    attrs: {
      "layout": "inline"
    }
  }, [_c('a-form-item', {
    attrs: {
      "help": _vm._trs('Delivery date')
    }
  }, [_c('a-date-picker', {
    attrs: {
      "placeholder": _vm._trs('Select date'),
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.date,
      callback: function callback($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  })], 1), _c('a-form-item', [_c('a-button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.search
    }
  }, [_vm._v(_vm._s(_vm._trs('Get results')))])], 1)], 1), _c('h5', {
    staticClass: "font-weight-light mb-3",
    staticStyle: {
      "margin-top": "70px"
    }
  }, [_vm._v(" " + _vm._s(_vm._trs('Blocks per day')) + " ")])], 1), _c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "table-scroll-wrapper"
  }, [_c('table', {
    staticClass: "border"
  }, [_c('th', {
    staticClass: "border-right text-center v-mid border-bottom",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(" " + _vm._s(_vm._trs('Block name')) + " ")]), _vm._l(_vm.availableDatesForBlocks, function (date) {
    return _c('th', {
      key: date,
      staticClass: "text-center text-danger border-right-table-cell border-bottom",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(" " + _vm._s(date) + " ")]);
  }), _c('tr', _vm._l(_vm.availableDatesForBlocks.length * 2, function (i) {
    return _c('td', {
      key: i,
      staticClass: "text-bold text-center border-right-table-cell border-bottom"
    }, [_vm._v(" " + _vm._s(i % 2 == 0 ? _vm._trs('Cijena [€/MWh]') : _vm._trs('Volume [MWh]')) + " ")]);
  }), 0), _vm._l(_vm.perBlockData, function (row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "border-right text-center"
    }, [_vm._v(" " + _vm._s(_vm.blockNames[index]) + " ")]), _vm._l(row, function (cell, idx) {
      return _c('td', {
        key: index + idx.toString(),
        staticClass: "text-center border-right-table-cell"
      }, [_vm._v(" " + _vm._s(cell) + " ")]);
    })], 2);
  })], 2)]), _c('h5', {
    staticClass: "font-weight-light mb-3 text-left",
    staticStyle: {
      "margin-top": "70px"
    }
  }, [_vm._v(" " + _vm._s(_vm._trs('Hourly data')) + " ")]), _c('div', {
    staticClass: "table-scroll-wrapper"
  }, [_c('table', {
    staticClass: "border"
  }, [_c('th', {
    staticClass: "border-right text-center v-mid border-bottom",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(" " + _vm._s(_vm._trs('Hour')) + " ")]), _vm._l(_vm.availableDatesDayAhead, function (date) {
    return _c('th', {
      key: date,
      staticClass: "text-danger text-center border-right-table-cell border-bottom",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(" " + _vm._s(date) + " ")]);
  }), _c('tr', _vm._l(_vm.availableDatesDayAhead.length * 2, function (i) {
    return _c('td', {
      key: i,
      staticClass: "text-center text-bold border-bottom border-right-table-cell"
    }, [_vm._v(" " + _vm._s(i % 2 == 0 ? _vm._trs('Cijena [€/MWh]') : _vm._trs('Volume [MWh]')) + " ")]);
  }), 0), _vm._l(_vm.hourlyData, function (row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-right border-right"
    }, [_vm._v(_vm._s(index + 1))]), _vm._l(row, function (cell, idx) {
      return _c('td', {
        key: index + idx.toString(),
        staticClass: "border-right-table-cell text-center"
      }, [_vm._v(" " + _vm._s(cell) + " ")]);
    })], 2);
  })], 2)])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }